import {
  ProductTypeEnum,
  ProductFamilyEnum,
  OwnOrPurchaseEnum,
  BorrowingEntityTypeEnum,
  PropertyTypeEnum,
  TimeLeftOnLeaseEnum,
  LoanRepaymentTypeEnum,
  LoanCompletionTypeEnum,
  InterestRateTypeEnum,
  FixedRateTermEnum,
  YesNoMaybe,
  TradingPeriodEnum,
  CommercialDeal,
} from "@src/apis/ModularClient";

export const initialDataSetUp = (dealDto: CommercialDeal, productType: ProductTypeEnum): CommercialDeal => {
  dealDto.isFamilyInResidence = YesNoMaybe.No;
  dealDto.hasIsFamilyInResidence = false;
  dealDto.hasOwnOrPurchase = false;
  dealDto.maxLoanRequired = true;
  dealDto.productType = productType;
  dealDto.productFamily = ProductFamilyEnum.Commercial;
  dealDto.ownOrPurchase = OwnOrPurchaseEnum.Purchasing;

  if (productType == ProductTypeEnum.CommercialInvestment) {
    dealDto.borrowingEntityType = BorrowingEntityTypeEnum.Company;
    dealDto.currentPropertyType = PropertyTypeEnum.MixedUse;
    dealDto.timeLeftOnLease = TimeLeftOnLeaseEnum.OneToThreeYears;
  }

  dealDto.loanRepaymentType = LoanRepaymentTypeEnum.Repayment;
  dealDto.loanCompletionType = LoanCompletionTypeEnum.JustCheckingMyOptions;
  dealDto.mortgageInterestType = InterestRateTypeEnum.Fixed;
  dealDto.fixedRateTerm = FixedRateTermEnum.FiveYear;
  dealDto.showLenderInfoBrokerOverride = true;
  dealDto.hasPostcode = true;

  if (productType == ProductTypeEnum.CommercialOwnerOccupied) {
    dealDto.borrowingEntityType = BorrowingEntityTypeEnum.Company;
    dealDto.tradingPeriod = TradingPeriodEnum.MoreThanTwoYears;
    dealDto.currentPropertyType = PropertyTypeEnum.Office;
  }

  dealDto.includesArrangementFee = false;
  return dealDto;
};

export const datasetupOnOwnOrPurchaseChange = (dealDto: CommercialDeal): CommercialDeal => {
  if (dealDto.ownOrPurchase != null && dealDto.ownOrPurchase == OwnOrPurchaseEnum.Purchasing) {
    dealDto.originalPurchaseDate = null;
    dealDto.currentvalue = null;
  }

  if (dealDto.ownOrPurchase != null && dealDto.ownOrPurchase == OwnOrPurchaseEnum.Own) {
    dealDto.purchasePrice = 0;
    dealDto.purchaseCosts = 0;
  }

  return dealDto;
};

export const datasetupOnCurrentUseOfBuilding = (dealDto: CommercialDeal): CommercialDeal => {
  if (dealDto.currentPropertyType != null && dealDto.currentPropertyType == PropertyTypeEnum.HMO) {
    dealDto.unitCount = null;
    dealDto.timeLeftOnLease = TimeLeftOnLeaseEnum.OneToThreeYears;
  } else if (
    dealDto.currentPropertyType != null &&
    dealDto.currentPropertyType == PropertyTypeEnum.MultiUnitFreeholdBlock
  ) {
    dealDto.bedroomCount = null;
    dealDto.timeLeftOnLease = TimeLeftOnLeaseEnum.OneToThreeYears;
  } else if (
    dealDto.currentPropertyType != null &&
    dealDto.currentPropertyType != PropertyTypeEnum.MultiUnitFreeholdBlock &&
    dealDto.currentPropertyType != PropertyTypeEnum.HMO
  ) {
    dealDto.bedroomCount = null;
    dealDto.unitCount = null;
  }

  return dealDto;
};

export const datasetupOnIsTenantedBuildingChange = (dealDto: CommercialDeal): CommercialDeal => {
  if (!dealDto.isTenantedBuilding) {
    dealDto.numberOfTenancies = null;
  }

  return dealDto;
};

const CommercialDealHelper = {
  initialDataSetUp,
  datasetupOnOwnOrPurchaseChange,
  datasetupOnCurrentUseOfBuilding,
  datasetupOnIsTenantedBuildingChange,
};

export default CommercialDealHelper;
